import React, { useEffect } from 'react';
import { useParams, useHistory } from "react-router-dom";
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';

import { visuallyHidden } from '@mui/utils';

import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';

import ClearOutlinedIcon from '@mui/icons-material/Clear';
import TextField from '@mui/material/TextField';

import { Button } from "@mui/material";

import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';

import SearchCaixasEscolaresBar from '../../../components/SearchCaixasEscolaresBar';
import EditPrintMenuConselho from '../../../components/EditPrintMenuConselho';

import Chip from '@mui/material/Chip';
import {Link} from 'react-router-dom';

import AutoCompleteSelectComponent from "../../../components/Controls/AutoCompleteSelectComponent";

import { formatTelefones } from '../../../utils/functions';

import api from '../../../services/api';

const rows = [];

function descendingComparator(a, b, orderBy) {

  if (b && b[orderBy] && b[orderBy].normalize("NFD").replace(/[\u0300-\u036f]/g, "") < a && a[orderBy] && a[orderBy].normalize("NFD").replace(/[\u0300-\u036f]/g, "")) {
    return -1;
  }
  if (b && b[orderBy] && b[orderBy].normalize("NFD").replace(/[\u0300-\u036f]/g, "") > a && a[orderBy] && a[orderBy].normalize("NFD").replace(/[\u0300-\u036f]/g, "")) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: 'caixaEscolarNome',
    numeric: false,
    disablePadding: true,
    label: 'Caixa Escolar',
    width: '25%',
    align: "left"
  },
  {
    id: 'termo',
    numeric: false,
    disablePadding: false,
    label: 'Termo',
    width: '8%',
    align: "center"
  },
  // {
  //   id: 'nomeCompleto',
  //   numeric: false,
  //   disablePadding: false,
  //   label: 'Unidade de Ensino',
  //   width: '20%',
  //   align: "left"
  // },
  {
    id: 'regiao',
    numeric: false,
    disablePadding: false,
    label: 'Regional',
    width: '8%',
    align: "left"
  },
  {
    id: 'bairro',
    numeric: false,
    disablePadding: false,
    label: 'Bairro',
    width: '15%',
    align: "left"
  },
  {
    id: 'presidenteNome',
    numeric: false,
    disablePadding: false,
    label: 'Presidente',
    width: '29%',
    align: "left"
  },
  {
    id: 'presidenteSituacaoMandato',
    numeric: false,
    disablePadding: false,
    label: 'Situação Inicial',
    width: '15%',
    align: "left"
  },
  
];

function EnhancedTableHead(props) {
  const { order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            size="small"
            width={headCell.width}
            align={headCell.align}
            key={headCell.id}
            padding='normal'
            sortDirection={orderBy === headCell.caixaEscolarNome ? order : false}
          >
            <TableSortLabel
              width={headCell.width}
              align={headCell.align}
              active={orderBy === headCell.caixaEscolarNome}
              direction={orderBy === headCell.caixaEscolarNome ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.caixaEscolarNome ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell>
          <span></span>
        </TableCell>
        
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  // onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  box: {
    height: 60,
    display: "flex",
    border: "",
    padding: 0
  },
  topLeftBox: {
    justifyContent: "flex-start",
    alignItems: "flex-start"
  },
  centerBox: {
    justifyContent: "center",
    alignItems: "center"
  },
  bottomRightBox: {
    justifyContent: "flex-end",
    alignItems: "flex-end"
  },
  spreadBox: {
    justifyContent: "space-between",
    alignItems: "center"
  }
}));

export default function EnhancedTable(props) {
  const query = useParams();
  const history = useHistory();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('caixaEscolarNome');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [listValues, setListValues] = React.useState([]);
  const [newListValues, setNewListValues] = React.useState([]);

  const getNewData = () => {
    const values = api.get("unidades-escolares");
    values.then((response) => {
      setListValues(response.data);
      setNewListValues(response.data);
    })
    .catch((err) => {
      console.error("ops! ocorreu um erro" + err);
    })
  }

  useEffect(() => {
    getNewData();
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const classes = useStyles();

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const setNewRegister = () => {
    history.push(`caixas-escolares/edit/new`)
  }

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
     const [searchField, setSearchField] = React.useState('');
     const [searchData, setSearchData] = React.useState([
       {regioes: []}, {bairros: []}, {tiposEnsinos: []}, {situacaoesMandato: []}
     ]);
     const handleChange = async (event) => {
      await setSearchField(event.target.value);
     };

     const handleDataSearch = async (data) => {
      setSearchData(data);
     };

     const setNewSearch = () => {
      //Doing filteration on according to select state option
      let newListValue = listValues;
      newListValue = listValues.filter(
        listValues => listValues.nomeCompleto.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          .includes(searchField.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()) ||
        listValues.caixaEscolarNome.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          .includes(searchField.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()) ||
        listValues.presidenteNome.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          .includes(searchField.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase())
      );
      if ((searchData) && (searchData[0].regioes.length > 0)) {
        newListValue = listValues.filter(
          listValues => searchData[0].regioes.includes(listValues.regiaoId)
        );
      }
      if ((searchData) && (searchData[1].bairros.length > 0)) {
        newListValue = listValues.filter(
          listValues => searchData[1].bairros.includes(listValues.bairroId)
        );
      }
      if ((searchData) && (searchData[2].tiposEnsinos.length > 0)) {
        newListValue = listValues.filter(
          listValues => searchData[2].tiposEnsinos
            .includes(listValues.unidadesEscolaresHasTiposEnsinosCodigos[0]) ||
            searchData[2].tiposEnsinos
            .includes(listValues.unidadesEscolaresHasTiposEnsinosCodigos[1]) ||
            searchData[2].tiposEnsinos
            .includes(listValues.unidadesEscolaresHasTiposEnsinosCodigos[2]) ||
            searchData[2].tiposEnsinos
            .includes(listValues.unidadesEscolaresHasTiposEnsinosCodigos[3])
        );
      }

      if ((searchData) && searchData[3]  && searchData[3].situacaoesMandato && (searchData[3].situacaoesMandato.length > 0)) {
        newListValue = listValues.filter(
          listValues => searchData[3].situacaoesMandato.includes(listValues.presidenteSituacaoMandatoId)
        );
      }

        //set state variable data after filteration
        setNewListValues(newListValue);
        // console.log(searchData)
      }

     useEffect(() => {
      setNewSearch();
     }, [searchField, searchData])

      const [isExpanded, setIsExpanded] = React.useState([]);
      const [totalValues, setTotalValues] = React.useState([]);
      const setIsExpandedData = async (id) => {
        let filtered = isExpanded;
        if (isExpanded.includes(id)) {
          filtered = isExpanded.filter(function(value, index, arr){ 
            return value !== id;
          });
        } else {
          filtered.push(id)
        }
        setIsExpanded(filtered)
       };

      useEffect(() => {
        setTotalValues(newListValues.length)
      }, [newListValues]);

  return (
    <React.Fragment>
    <CssBaseline />
    {/* <Container maxWidth="xl">
      <Typography component="div" style={{ height: '100vh - 48px' }}>
        <Paper elevation={3}sx={{ p: 1, m: 2, display: 'flex', flexDirection: 'column' }}>
          <div> */}

          {/*<pre>{JSON.stringify(searchData, null, 2)}</pre>*/}

            <Box sx={{ width: '100%', mt: 2 }}>
              {/* <Paper sx={{ width: '100%', mb: 2 }}> */}

                <Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ flex: '100%', px: 4 }}>

                  <Grid item xs={4}>
                    <Box>
                      <Typography component="div">
                        <Box sx={{ fontWeight: 'light', fontSize: 20, color: '#A9A9A9', pt: 2 }}>Presidentes Caixas Escolares - Listagem</Box>
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={8}>
                    <Box
                      component="div"
                      className={`${classes.bottomRightBox} ${classes.box}`}>
                      <div style={{ paddingRight: 20 }}>
                        <Paper
                          component="form"
                          sx={{ display: 'flex', alignItems: 'center', width: 400 }}
                        >
                          <IconButton sx={{ p: '6px' }} aria-label="search">
                            <SearchIcon />
                          </IconButton>
                          <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            size="small"
                            placeholder="Pesquisar ..."
                            inputProps={{ 'aria-label': 'Pesquisar', style: { textTransform: "uppercase", fontSize: 12 } }}
                            onChange={handleChange}
                            value={searchField}
                          />
                          { searchField.length > 0 ? 
                            <IconButton sx={{ p: '6px' }} aria-label="search" onClick={() => setSearchField('')}>
                              <ClearOutlinedIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                            : null }
                        </Paper>
                      </div>
                      <div style={{ paddingRight: 20 }}>
                        <Paper
                          component="form"
                          sx={{ display: 'flex', alignItems: 'center', width: 100 }}
                        >
                          <TextField
                            // className={classes.input}
                            size="small"
                            id="total"
                            color="primary"
                            label="Total"
                            variant="outlined"
                            value={totalValues ? String(totalValues).padStart(2, '0') : '00'}
                            inputProps={{ style: { textAlign: "center" } }}
                          />
                        </Paper>
                      </div>

                      <div>
                        <Button onClick={() => setNewRegister()} variant="outlined" color="primary" size="small" style={{ height: 35 }}>
                          Novo
                        </Button>
                      </div>
                    </Box>
                  </Grid>

                </Grid>

                <Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ flex: '100%', px: 4 }}>
                  <Grid item sx={{ flex: '100%', pt: 2 }}>
                    <div><SearchCaixasEscolaresBar onSelectData={handleDataSearch} /></div>
                  </Grid>
                </Grid>

                <TableContainer sx={{ maxHeight: 500 }}>
                  <Table
                    sx={{ minWidth: 750 }}
                    aria-labelledby="tableTitle"
                    size='small'
                    stickyHeader
                  >
                    <EnhancedTableHead
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                      rowCount={newListValues && newListValues !== 'undefined' ? newListValues.length : 0}
                    />
                    <TableBody>
                      {stableSort(newListValues, getComparator(order, orderBy))
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.caixaEscolarNome);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <>
                              <TableRow
                                hover
                                onClick={(event) => handleClick(event, row.caixaEscolarNome)}
                                key={row.id}
                              >
                                <TableCell padding="checkbox" key={row.id}>
                                  <IconButton onClick={() => setIsExpandedData(row.id)}>
                                    {isExpanded.includes(row.id) ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                  </IconButton>
                                </TableCell>

                                <TableCell
                                  component="th"
                                  id={labelId}
                                  scope="row"
                                  padding="normal"
                                  sx={{ fontSize: 13 }}
                                >
                                  <span align="left" style={{ fontSize: 12 }} sx={{ minWidth: 125, padding: 0 }}>
                                    {row.caixaEscolarNome}
                                  </span>
                                  <br />
                                  <span style={{ fontSize: 12, color: '#BEBEBE' }}>{row.nomeCompleto}&nbsp;</span>
                                </TableCell>

                                <TableCell align="center" sx={{ fontSize: 13 }}>{row.termo}</TableCell>
                                {/*<TableCell align="left" sx={{ fontSize: 13 }}>{row.nomeCompleto}</TableCell>*/}

                                <TableCell align="left" sx={{ fontSize: 13 }}>{row.regiao}</TableCell>
                                <TableCell align="left" sx={{ fontSize: 13 }}>{row.bairro}</TableCell>

                                <TableCell align="left" sx={{ fontSize: 13, cursor: row.presidenteNome && row.presidenteNome.length > 0 ? 'pointer': 'auto', color: '#4a89c8' }} >
                                  <span onClick={() => history.push(`/conselho-fiscal-escolar/edit/${row.presidenteId}`)}>
                                    {row.presidenteNome}
                                  </span>
                                </TableCell>
                                
                                <TableCell align="left" sx={{ fontSize: 13 }}>
                                  {
                                    row.presidenteSituacaoMandato ?
                                    <Chip
                                      label={row.presidenteSituacaoMandato}
                                      size="small"
                                      color={row.presidenteSituacaoMandatoColor}
                                      variant="outlined"
                                    />
                                    : <></>
                                  }
                                </TableCell> 

                                <TableCell align="left" sx={{ fontSize: 13 }}>
                                <EditPrintMenuConselho
                                  row={row}
                                  getNewData={getNewData}
                                  />
                                </TableCell>
                              </TableRow>
                              {isExpanded.includes(row.id) && (
                                <>
                                  <TableRow>
                                    <TableCell padding="checkbox" />
                                    <TableCell colSpan={7}>
                                      <span><b>Termo:&nbsp;</b></span><span>{row.termo}&nbsp;-&nbsp;</span>
                                      <span><b>Código Credor:&nbsp;</b></span><span>{row.codigoCredor}</span>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell padding="checkbox" />
                                    <TableCell colSpan={7}><span><b>CNPJ:&nbsp;</b></span><span>{row.cnpj}</span></TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell padding="checkbox" />
                                    <TableCell colSpan={7}>
                                      <span>
                                        <b>Endereço:&nbsp;</b></span><span>{`${row.logradouro}, ${row.numero}`} {row.complementos ? - row.complementos : ''}
                                        <span>&nbsp;-&nbsp;</span>
                                        <span><b>Bairro:&nbsp;</b></span><span>{row.bairro}</span>
                                        <span>&nbsp;-&nbsp;</span>
                                        <span><b>Região:&nbsp;</b></span><span>{row.regiao}</span>
                                      </span>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell padding="checkbox" />
                                    <TableCell colSpan={7}><span><b>Cidade/Estado:&nbsp;</b></span><span>{row.cidade}&nbsp;-&nbsp;{row.estado}</span></TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell padding="checkbox" />
                                    <TableCell colSpan={7}><span><b>E-mail:&nbsp;</b></span><span>{row.email}</span></TableCell>
                                  </TableRow>
                                  <TableRow>
                                      <TableCell padding="checkbox" />
                                      <TableCell colSpan={7}><span><b>Telefone(s):&nbsp;</b></span><span>{formatTelefones(row.numerosTelefones)}</span></TableCell>
                                      {/*<TableCell colSpan={7}><span><b>Telefone(s):&nbsp;</b></span><span>{JSON.stringify(formatTelefones(row.numerosTelefones), null, 2)}</span></TableCell>*/}
                                    </TableRow>
                                </>
                              )}
                            </>
                          );
                        })}

                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}
                        >
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              {/* </Paper> */}
            </Box>
          {/* </div>
        </Paper>
      </Typography>
    </Container> */}
    </React.Fragment>
  );
}
